import SanityClient from '@sanity/client';

export default SanityClient({
	projectId: 'bxh8mfbv',
	dataset: 'production',
	apiVersion: 'v2021-08-31',
});
// useCdn: true,
